import { CHANGE_GLOBAL_PROPS, COTIZACIONES } from '../action-types';
import { createAction } from 'redux-actions';

// Action Creators

export const changeGlobalProps = createAction(CHANGE_GLOBAL_PROPS, (props) => props);

export const saveCotizaciones = createAction(COTIZACIONES, (props) => props);
